import moment from "moment";
import { NameStatusLicense, detectCurrentNameStatus, getStatusData } from "../../helpers";
import { License, User } from "../../model";
import { FC } from "react";
import ImageSprite from "../../../../assets/components/ImageSprite/ImageSprite";
import CheckImg from "../Img/check.svg";

export interface LicenseInfoPanel {
    expirationDate: License["activations"][0]["expirationDate"];
    activationDate: License["activations"][0]["activationDate"];
    type?: License["type"];
    resellerName: User["resellerName"];
    status: License["status"];
    migrationKeyId: License["migrationKeyId"];
    orderId: License["orderId"];
    reason?: License["reason"];
}

type Props = {
    info: LicenseInfoPanel;
};

const LicenseKeysInformPanel: FC<Props> = ({ info }) => {
    const availableNameDay = (day: number) => {
        return day > 2 ? " days" : " day";
    };

    const unixExpirationDate = info?.expirationDate;
    const unixActivationData = info?.activationDate;

    const liveTimeDaysFormat = moment
        .unix(unixExpirationDate)
        .diff(moment.unix(unixActivationData), "days"); // expirationDate - activationData
    const daysPastDaysFormat = moment
        .unix(moment().unix())
        .diff(moment.unix(unixActivationData), "days"); // current day - activationData
    const daysLeftDaysFormat = moment
        .unix(unixExpirationDate)
        .diff(moment.unix(moment().unix()), "days"); // current day - unixExpirationDate
    const expirationDateTime = moment.unix(unixExpirationDate).format("LLL");

    if (!unixExpirationDate && !unixActivationData) {
        return (
            <>
                <div className="row__item">
                    <div className="row__label">Reseller:</div>
                    <div className="row__data">{info.resellerName}</div>
                </div>
                {info.orderId && (
                    <div className="row__item">
                        <div className="row__label">Order Id:</div>
                        <div className="row__data">{info.orderId}</div>
                    </div>
                )}
                <div className="row__item">
                    <div className="row__label">
                        <span className="status_color green">Duration:</span>
                    </div>
                    <div className="row__data">
                        <span className="status_color green">
                            {info.type === 0 ? "Lifetime" : "Subscription"}
                        </span>
                    </div>
                </div>
                <div className="row__item">
                    <div className="row__label">Status:</div>
                    <div className="row__data">{getStatusData(info.status)?.name}</div>
                </div>
                {info.reason && (
                    <div className="row__item">
                        <div className="row__label">Reason:</div>
                        <div className="row__data">{info.reason}</div>
                    </div>
                )}
            </>
        );
    }

    const getAvailableLiveTime = () => {
        if (info.type === 0) return "Lifetime";
        if (info.type === 1) {
            if (unixExpirationDate !== 0)
                return `Subscription ${liveTimeDaysFormat} ${availableNameDay(liveTimeDaysFormat)}`;
            return "Subscription";
        }
    };

    return (
        <>
            <div className="row__item">
                <div className="row__label">Reseller:</div>
                <div className="row__data">{info.resellerName}</div>
            </div>

            {info.orderId && (
                <div className="row__item">
                    <div className="row__label">Order Id:</div>
                    <div className="row__data"> {info.orderId}</div>
                </div>
            )}

            <div className="row__item ">
                <div className="row__label">
                    <span className="status_color green">Duration:</span>
                </div>
                <div className="row__data">
                    <span className="status_color green">
                        {getAvailableLiveTime()}
                    </span>
                </div>
            </div>

            {!detectCurrentNameStatus(info.status, [
                NameStatusLicense.DEACTIVATED,
                NameStatusLicense.NOT_ACTIVATED,
            ]) && (
                <>
                    {info.type === 1 && unixExpirationDate !== 0 && (
                        <>
                            <div className="row__item status_color red">
                                <div className="row__label">
                                    <span className="status_color red">
                                        Expiration date:
                                    </span>
                                </div>
                                <div className="row__data">
                                    <span className="status_color red">
                                        {expirationDateTime}
                                    </span>
                                </div>
                            </div>

                            <div className="row__item">
                                <div className="row__label">Days Left:</div>
                                <div className="row__data">
                                    {daysLeftDaysFormat}{" "}
                                    {availableNameDay(daysLeftDaysFormat)}
                                </div>
                            </div>
                        </>
                    )}

                    {info.type === 1 && unixExpirationDate !== 0 && (
                        <div className="row__item">
                            <div className="row__label">Days Passed:</div>
                            <div className="row__data">
                                {daysPastDaysFormat}{" "}
                                {availableNameDay(daysPastDaysFormat)}
                            </div>
                        </div>
                    )}

                    <div className="row__item row__item_migrated">
                        <div className="row__label">Migrated:</div>
                        <div className="row__data">
                            <ImageSprite
                                iconSprite={`${CheckImg}${
                                    info.migrationKeyId !== null
                                        ? "#checked"
                                        : "#unchecked"
                                }`}
                            />
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default LicenseKeysInformPanel;
